module.exports = __webpack_public_path__ + "4b045d31704722b11ee3839fa32f2339.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-320.webp.png
// module id = 343
// module chunks = 0